<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    style="z-index: 1000;"
  >
    <!--
      Background overlay, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
      Modal panel, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <Alert
        v-if="pendingTemplate && pendingTemplate.message"
        :text="
          'Your template is yet to be approved by whatsapp, We will update you by email, once the template is added'
        "
        :type="'warning'"
      ></Alert>
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Custom {{ getHeaderLabel(templateType) }} Template Approval
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <div class="mt-4">
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            <div class="flex justify-between items-center my-2">
              <span>Content</span>
              <AutomationVariableDropdown
                :templateType="templateType"
                @onItemClicked="insertAtCursor"
              />
            </div>
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <textarea
              style="    min-height: 240px;"
              ref="content"
              v-model="form.message"
              class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            :disabled="$v.form.$invalid"
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter disabled:opacity-50"
            type="button"
            @click="onCreate"
          >
            <span
              class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
              >Submit for Approval</span
            >
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AutomationVariableDropdown from "./AutomationVariableDropdown.vue";

import { required } from "vuelidate/lib/validators";
import Alert from "../Common/Alert.vue";

export default {
  components: {
    AutomationVariableDropdown,
    Alert
  },
  props: {
    templateType: {
      type: String
    }
  },
  validations: {
    form: {
      message: {
        required
      }
    }
  },
  data() {
    return {
      form: {
        message: ""
      },
      pendingTemplate: {}
    };
  },
  mounted() {
    this.$refs.content.focus();
    if (this.templateType != "upsell") {
      this.getPendingTemplate();
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onCreate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store
        .dispatch("addTemplateForApproval", {
          requestParams: {
            type: this.templateType,
            message: this.form.message
          }
        })
        .then(response => {
          this.pendingTemplate = response.template;
          this.sendToCrisp();
          this.close();
        });

      // this.close();
    },
    getPendingTemplate() {
      this.$store
        .dispatch("getPendingTemplate", { type: this.templateType })
        .then(response => {
          if (response.pendingTemplate) {
            this.pendingTemplate = response.pendingTemplate;
            this.form.message = this.pendingTemplate.message;
          }
        });
    },
    sendToCrisp() {
      // $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        ["text", `Template Approval : \n\n ${this.form.message}`]
      ]);
    },

    getHeaderLabel(type) {
      switch (type) {
        case "abandoned_cart_2":
        case "abandoned_cart_3":
        case "abandoned_cart":
          return "Abandoned cart";

        case "order_confirmation":
          return "Order Confirmation";

        case "order_shipping":
          return "Order Shipping";

        case "cod_order":
          return "COD order confirmation";

        case "reviews":
          return "Reviews ";

        default:
          return "";
      }
    },
    insertAtCursor(myValue) {
      const myField = this.$refs.content;
      //IE support
      if (document.selection) {
        myField.focus();
        sel = document.selection.createRange(); // eslint-disable-line
        sel.text = myValue; // eslint-disable-line
      }
      //MOZILLA and others
      else if (myField.selectionStart || myField.selectionStart == "0") {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value =
          myField.value.substring(0, startPos) +
          myValue +
          myField.value.substring(endPos, myField.value.length);
      } else {
        myField.value += myValue;
      }
      this.form.message = myField.value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
